app.controller('ridesAddCtrl', ['$scope', '$rootScope', '$state', '$stateParams', '$http', '$mdDialog', '$mdMedia', '$mdToast', 'Upload', 'exerciseService',
	function ($scope, $rootScope, $state, $stateParams, $http, $mdDialog, $mdMedia, $mdToast, Upload, exerciseService) {
		var vm = this;

		var tivoliCenter = [12.5680196, 55.6737266];

		vm.form = {};
		vm.submitting = false;

		vm.model = {
			key: "",
			name: "",
			location: tivoliCenter,
			markerImage: null,
			markerWidth: 0,
			markerHeight: 0,
			markerScaleFactor: 0,
			markerZIndex: 0,
			enabled: false
		};

		vm.ride = null;
		vm.loading = false;
		if ($stateParams.id) {
			vm.loading = true;
			$http.get('/api/rides/' + $stateParams.id).then(function(response) {
				var ride = response.data;
				if (ride) {
					vm.model = ride;
					vm.ride = ride;
					if (vm.ride.markerScaleFactor == 0) {
						vm.ride.markerScaleFactor = 1.0;
					}
					vm.loading = false;
				}
			});
		}

		vm.uploading = false;
		vm.upload = function (file) {
			if (file == null) {
				return;
			}

			FD.BlobToDataURL(file).then(function(dataUrl) {
				vm.model.markerImage = dataUrl;
			});
        }

        vm.removeImage = function(evt) {
        	evt.preventDefault();

        	var confirm = $mdDialog.confirm()
	            .title('Fjern billede?')
	            .textContent('Er du sikker på at du vil fjerne dette billede?')
	            .ariaLabel('Fjern billede')
	            .targetEvent(evt)
	            .ok('Fjern')
	            .cancel('Anullér');
        	$mdDialog.show(confirm).then(function () {
				vm.model.markerImage = null;
			});
        }

		vm.map = new maptalks.Map('maptalksc', {
        	center: vm.model.location,
        	zoom: 16.64,
        	bearing: 150.0,
        	attribution: false,

	        //allow map to drag pitching, true by default
        	dragPitch : false,
        	//allow map to drag rotating, true by default
        	dragRotate : true,
        	//enable map to drag pitching and rotating at the same time, false by default
        	dragRotatePitch : false,

        	baseLayer: new maptalks.TileLayer('base', {
          		urlTemplate: 'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png',
          		subdomains: ['a','b','c','d'],
          		attribution: ''
        	})
      	});

		var center = vm.map.getCenter();
		vm.mapOverlayLayer = new maptalks.VectorLayer('vector').addTo(vm.map);

        // Add the go-to pos
      	vm.targetMarker = new maptalks.Marker(
      		vm.model.location,
        	{
	          	'symbol' : {
	            	'markerFile'   : window.location.origin + '/img/map/MapPin.svg',
	            	'markerWidth'  : 2*22,
	            	'markerHeight' : 2*35.5,
	            	'markerDx'     : 0,
	            	'markerDy'     : 0,
	            	'markerOpacity': 1
	          	}
	    	}
      	);
      	vm.targetMarker.addTo(vm.mapOverlayLayer);

      	$scope.$watch('vm.model.location', angular.bind(vm, function() {
      		vm.targetMarker.setCoordinates(vm.model.location);
      	}), true);

      	vm.map.on('click', function(evt) {
      		$scope.$apply(function() {
	      		vm.targetMarker.setCoordinates(evt.coordinate);
	       		vm.model.location = [evt.coordinate.x, evt.coordinate.y];
	      	});
      	});

      	vm.resetMap = function() {
      		vm.map.setCenter(tivoliCenter);
      		vm.map.setZoom(16.64);
      		vm.map.setBearing(150.0);
      	}

       	vm.save = function () {
            if (!vm.form.$valid)
                return;
            vm.submitting = true;

            if (vm.exercise) {
            	vm.model.id = vm.ride.id; // XXX
	            $http.post('api/rides', vm.model, {headers: {'Content-Type': 'application/json'}})
	                .then(function (resp) {
	                    $mdToast.show(
	                        $mdToast.simple()
	                        .textContent("Forlystelse opdateret")
	                        .position('top right')
	                        .hideDelay(3000)
	                    );
	                    $state.go('rides.details', {'id': resp.data.key}, { reload: true });
	                }, function (err) {
	                    vm.submitting = false;
	                    if (err.status === 409) {
	                        vm.form.name.$setValidity("taken", false);
	                    }
	                });
            } else {
	            $http.put('api/rides', vm.model, {headers: {'Content-Type': 'application/json'}})
	                .then(function (resp) {
	                    $mdToast.show(
	                        $mdToast.simple()
	                        .textContent("Forlystelse tilføjet")
	                        .position('top right')
	                        .hideDelay(3000)
	                    );
	                    $state.go('rides.details', {'id': resp.data.key}, {reload: true});
	                }, function (err) {
	                    vm.submitting = false;

	                    if (err.status === 409) {
	                        vm.form.name.$setValidity("taken", false);
	                    }
	                });
	        }
        }
	}
]);